module.exports = __webpack_public_path__ + "img/flag_gif.5e50c489.gif";